<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
import axios from 'axios';
export default {
  data() {
    return {
      cdata: {
        xData: ["辊分空货位", "辊分满货位", "极库空货位", "极库满货位", "切卷空货位", "切卷满货位"],
        seriesData: [
          { value: 5, name: "辊分空货位" },
          { value: 10, name: "辊分满货位" },
          { value: 15, name: "极库空货位" },
          { value: 20, name: "极库满货位" },
          { value: 25, name: "切卷空货位" },
          { value: 30, name: "切卷满货位" },

        ]
      }
    }
  },
  components: {
    Chart,
  },
  mounted() {
    this.changeTiming()
  },
  methods: {
    changeTiming() {
        this.changeNumber()
      setInterval(() => {
        this.changeNumber()
      }, 60000)
    },
    changeNumber() {
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetLocationEmptyOrStored", {
      // axios.post("http://127.0.0.1:8098/api/ToWMS/GetLocationEmptyOrStored", {
        MainData: {
          AGVName: "组装AGV调度"
        }
      }).then((res) => {
        let agvs = res.data.data
        let GetLocationEmptyOrStored = [
          {value:agvs.gfEmptyNum,name:"辊分空货位"},
          {value:agvs.gfStoredNum,name:"辊分满货位"},
          {value:agvs.jkEmptyNum,name:"极库空货位"},
          {value:agvs.jkStoredNum,name:"极库满货位"},
          {value:agvs.qjEmptyNum,name:"切卷空货位"},
          {value:agvs.qjStoredNum,name:"切卷满货位"}
        ]
        this.cdata.seriesData = GetLocationEmptyOrStored
      }).catch((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>